<template>
  <div id="app_signup">
    <ServerError v-if="ServerError" />
    <v-layout wrap justify-center>
      <v-flex xs12 md12 pa-8>
        <v-card id="app_height" outlined tile>
          <div>
            <v-layout pt-12></v-layout>
            <v-layout pt-12></v-layout>
            <v-layout fill-height grid-list-md text-xs-center>
              <v-flex>
                <v-flex xs12 md12>
                  <v-img src="../../assets/icons/tick.png" aspect-ratio="1" contain height="50px">
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-flex>
                <v-flex xs12 md12 pt-5 text-center>
                  <!-- <span style="font-size:16px;font-weight:500;">Email Verified Successfully</span> -->
                  <span style="font-size:16px;font-weight:500;">{{msg}}</span>
                </v-flex>
                <!-- <v-layout wrap justify-center> -->
                <v-flex xs12 md12 align="center">
                  <v-img src="../../assets/person.png" contain height="200px">
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-flex>
              </v-flex>
            </v-layout>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["id", "authcode"],
  data() {
    return {
      msg: null,
      ServerError: false
    };
  },
  mounted() {
    this.verifyEmail();
  },
  methods: {
    verifyEmail() {
      var verdata = {};
      verdata["id"] = this.id;
      verdata["authcode"] = this.authcode;
      axios({
        method: "POST",
        url: "/user/verifyemail",
        data: verdata
        // params: {
        //   id: this.id,
        //   authcode: this.authcode
        // }
      })
        .then(response => {
          this.msg = response.data.msg;
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    }
  }
};
</script>
<style scoped>
.verimg.v-image__image--cover {
  background-size: contain !important;
}
#app_signup {
  background-image: url("../../assets/home_header.png");
  background-repeat: no-repeat;
  background-size: cover;
  color: white;
}
@media only screen and (min-width: 800px) {
  #app_height {
    min-height: 72.5vh;
  }
}
</style>